import React from 'react'
import PropTypes from 'prop-types'
import Swatch from './Swatch'

const SwatchPicker = ({ colors, value, onSelect, disabled }) => (
  <div className="tw:inline-flex tw:items-center tw:gap-1">
    {colors.map(color => (
      <Swatch
        key={color}
        color={color}
        disabled={disabled}
        selected={color === value}
        onSelect={onSelect}
      />
    ))}
  </div>
)

SwatchPicker.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.string).isRequired,
  disabled: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  value: PropTypes.string
}

SwatchPicker.defaultProps = {
  disabled: false,
  value: null
}

export default SwatchPicker
